import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, PhoneCall, MessageCircle, CalendarCheck } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

const STEPS = [
  { icon: PhoneCall, title: "Ti chiamiamo", text: "Un nostro consulente ti contatterà nella fascia oraria che hai indicato." },
  { icon: MessageCircle, title: "Anche su WhatsApp", text: "Se non rispondi, ti scriveremo un messaggio WhatsApp per riprogrammare." },
  { icon: CalendarCheck, title: "Analisi del salone", text: "Valuteremo insieme se e come il metodo a % può funzionare per il tuo salone." },
];

export default function Grazie() {
  return (
    <div className="bg-[#2B1930] pv-grain min-h-screen flex flex-col" data-testid="grazie-page">
      <Navbar dark />
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 pt-40 pb-24 text-center">
        <motion.div
          initial={{ scale: 0, rotate: -30 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 200, damping: 15, delay: 0.2 }}
          className="h-24 w-24 rounded-full bg-[#D83A52] flex items-center justify-center shadow-[0_0_60px_rgba(216,58,82,0.5)] mb-10"
        >
          <Check className="h-12 w-12 text-white" strokeWidth={3} />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-black text-[#F7F2EA] leading-[1.1] max-w-3xl"
          data-testid="grazie-headline"
        >
          Richiesta inviata <span className="italic text-[#D83A52]">correttamente</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="mt-6 text-lg text-[#F7F2EA]/70 max-w-xl"
        >
          Verrai contattato da noi al più presto.
        </motion.p>

        <div className="mt-16 grid sm:grid-cols-3 gap-6 max-w-3xl w-full">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8 + i * 0.15, duration: 0.7 }}
              className="rounded-2xl bg-[#F7F2EA]/5 border border-[#C8A6A1]/20 p-6 text-left"
            >
              <s.icon className="h-6 w-6 text-[#D83A52] mb-4" />
              <h3 className="font-display text-lg font-bold text-[#F7F2EA] mb-1.5">{s.title}</h3>
              <p className="text-xs leading-relaxed text-[#F7F2EA]/60">{s.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.4 }}
          className="mt-14"
        >
          <Link
            to="/"
            data-testid="grazie-home-link"
            className="text-sm text-[#C8A6A1] underline hover:text-[#D83A52] transition-colors"
          >
            Torna alla home
          </Link>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
}
